import { render, staticRenderFns } from "./AccountingBySupplier.vue?vue&type=template&id=1f629c16&scoped=true"
import script from "./AccountingBySupplier.vue?vue&type=script&lang=js"
export * from "./AccountingBySupplier.vue?vue&type=script&lang=js"
import style0 from "./AccountingBySupplier.vue?vue&type=style&index=0&id=1f629c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f629c16",
  null
  
)

export default component.exports